<template>
  <div>
    <div v-if="isPagination" class="vpagination">
      <div class="columns">
        <div class="column is-four-fifths">
          <span>Page </span>
          <button
            class="button is-small"
            :disabled="currentPage === 1"
            @click="prevPage()"
          >
            <i class="fa fa-chevron-left" />
          </button>
          <span style="padding-left: 4px; padding-right: 4px">
            {{ currentPage }} of {{ totalPages }}
          </span>
          <button
            class="button is-small"
            :disabled="currentPage === totalPages"
            @click="nextPage()"
          >
            <i class="fa fa-chevron-right" />
          </button>
          <span style="padding-left: 4px; padding-right: 4px">| View </span>
          <div class="select">
            <select v-model="pageSize" @change="updateTable()">
              <option v-for="page in pages" :key="page">
                {{ page }}
              </option>
            </select>
          </div>
          <span style="padding-left: 4px; padding-right: 4px"
            >records | Found total {{ filteredContent.length }} records</span
          >
          <span v-if="filteredContent.length !== content.length">
            (filtered from {{ content.length }} total entries)
          </span>
        </div>
        <div>
          <input
            ref="searchText"
            v-model="searchText"
            class="input"
            type="text"
          />
        </div>
      </div>
    </div>
    <table class="vtable has-background-white">
      <thead>
        <tr>
          <th
            v-for="(col, colIndex) in header"
            :key="colIndex"
            :style="{ width: col.width ? col.width : 'auto' }"
            :class="{ 'clickable pos-rel': !(col.isSortable === false) }"
            :hidden="col.ishidden"
            @click="sortTable(col)"
          >
            {{ col.value }}
            <span
              v-if="col.key == sortColumn"
              class="icon pos-abs r-0"
              :class="ascending ? 't-9' : 't-5'"
            >
              <i
                class="fa"
                :class="ascending ? 'fa-sort-asc' : 'fa-sort-desc t-t'"
              />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, rowIndex) in getRows()" :key="rowIndex">
          <td
            v-for="(col, colIndex) in header"
            :hidden="col.ishidden"
            :key="colIndex"
          >
            <slot v-if="col.custom" name="content" :data="{ row, col }" />
            <template v-else>
              <template v-if="col.onClick">
                <a
                  v-if="mark"
                  :inner-html.prop="row[col.key]"
                  tabindex="0"
                  style="cursor: pointer"
                  @keyup.enter="col.onClick(row)"
                  @click="col.onClick(row)"
                >
                  {{ row[col.key] }}</a
                >
                <a
                  v-else
                  :inner-html.prop="row[col.key]"
                  @click="col.onClick(row)"
                >
                  {{ row[col.key] }}</a
                >
              </template>
              <template v-else>
                <span
                  v-if="mark && isPagination && col.type == 'DateTime'"
                  :inner-html.prop="row[col.key]"
                >
                  {{ convertToDateTime(row[col.key]) }}
                  <!-- {{ row[col.key] }} -->
                </span>
                <span
                  v-else-if="mark && isPagination && col.type == 'Date'"
                  :inner-html.prop="row[col.key]"
                >
                  {{ convertToDate(row[col.key]) }}
                  <!-- {{ row[col.key] }} -->
                </span>
                <span
                  v-else-if="mark && isPagination"
                  :inner-html.prop="row[col.key]"
                >
                  {{ row[col.key] }}
                </span>
                <span v-else-if="col.type && col.type === 'Date'">
                  {{ row[col.key] }}
                  <small v-if="col.secondaryItem" class="p-l-xs">
                    {{ row[col.secondaryItem] }}
                  </small>
                </span>
                <span v-else>
                  {{ row[col.key] }}
                  <small v-if="col.secondaryItem" class="p-l-xs">
                    <template
                      v-if="
                        col.secondaryItemType &&
                        col.secondaryItemType === 'DateTime'
                      "
                    >
                      {{ row[col.secondaryItem] }}
                    </template>
                    <template v-else>
                      {{ row[col.secondaryItem] }}
                    </template>
                  </small>
                </span>
              </template>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "VTable",
  props: {
    header: {
      type: Array,
      required: true,
    },
    content: {
      type: Array,
      required: true,
    },
    isPagination: {
      type: Boolean,
      required: false,
      default: true,
    },
    mark: {
      type: Boolean,
      required: false,
      default: true,
    },
    elementsPerPage: {
      type: Number,
      required: false,
      default: 15,
    },
    pages: {
      type: Array,
      required: false,
      default: () => [15, 50, 100, "All"],
    },
    colHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
    dataHidden: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      // elementsPerPage: 15,
      // pages: [ 15, 50, 100 ]
      ascending: false,
      sortColumn: "",
      searchText: "",
      pageSize: this.elementsPerPage,
      isDataHidden: false,
      isColHdrHidden: false,
    };
  },
  computed: {
    totalPages() {
      if (this.pageSize == "All") {
        return 1;
      }
      return Math.ceil(this.filteredContent.length / parseInt(this.pageSize));
    },
    filteredContent() {
      if (this.searchText.length > 0) {
        return this.content.filter((item) => {
          return Object.keys(item).some(
            (key) =>
              item[key] !== null &&
              this.header.filter((h) => h.key === key).length &&
              item[key]
                .toString()
                .toLowerCase()
                .includes(this.searchText.toLowerCase())
          );
        });
      } else {
        return this.content;
      }
    },
  },
  watch: {
    totalPages() {
      this.currentPage = 1;
    },
  },
  mounted() {
    if (this.isPagination) {
      this.$refs.searchText.focus();
    }
  },
  methods: {
    sortTable(col) {
      this.$emit("sortTable");
      const isSortable = col.isSortable === false ? false : true;
      if (isSortable) {
        if (this.sortColumn === col.key) {
          this.ascending = !this.ascending;
        } else {
          this.ascending = true;
          this.sortColumn = col.key;
        }
        const ascending = this.ascending;
      }
    },
    numPages() {
      return Math.ceil(this.filteredContent.length / parseInt(this.pageSize));
    },
    getRows() {
      if (this.pageSize == "All") {
        const start = (this.currentPage - 1) * parseInt(this.pageSize);
        const end = parseInt(this.filteredContent.length);
        this.totalPages = 1;
        return this.filteredContent.slice(start, end);
      }
      const start = (this.currentPage - 1) * parseInt(this.pageSize);
      const end = start + parseInt(this.pageSize);
      return this.filteredContent.slice(start, end);
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage = this.currentPage + 1;
      }
    },

    updateTable() {
      this.getRows();
      this.numPages();
    },
    convertToDate(date) {
      if (!date) {
        date = new Date();
      }
      if (typeof date !== "object") {
        return `${date.substring(8, 10)}/${date.substring(5,7)}/${date.substring(0, 4)}`;
      }
    },
    convertToDateTime(date) {
      if (!date) {
        date = new Date();
      }
      if (typeof date !== "object") {
        return `${date.substring(8, 10)}/${date.substring(5,7)}/${date.substring(0, 4)}  ${date.substring(11, 13)}:${date.substring(14,16)}:${date.substring(17, 19)} `;
      }
    },
  },
};
</script>

<style lang="scss">
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.vpagination {
  font-size: 13px;
  .button.is-focused {
    border-color: #b5b5b5;
  }
  .input {
    // width: 36px;
    font-size: 13px;
    height: 2.3em;
  }
  .select {
    height: 2.3em;
    line-height: 1em;
    display: inline-block;
  }
  span {
    position: relative;
    top: 6px;
  }
  .button {
    border-radius: 0;
    .fa {
      font-size: 9px;
    }
    &:focus {
      border-color: #b5b5b5;
    }
    &:focus:not(:active),
    &.button.is-focused:not(:active) {
      box-shadow: none;
    }
  }
}
.container {
  .columns:last-child {
    margin-bottom: 0;
  }
}
.button.is-small {
  border-radius: 1px;
  font-size: 0.4rem;
}
.select select {
  cursor: pointer;
  display: block;
  font-size: 1em;
  max-width: 100%;
  outline: none;
}
.select select:not([multiple]) {
  padding-right: 2.5em;
}
.columns {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  margin-top: -0.75rem;
  display: flex;
}

.column {
  flex: none;
  width: 80%;
  display: block;
  padding: 0.75rem;
}
*,
:after,
:before {
  box-sizing: inherit;
}
.column.is-four-fifths {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: auto;
  width: 80%;
}
.vtable {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e7ecf1;
  th {
    text-align: left;
    padding: 8px;
    min-width: 30px;
    border: 1px solid #e7ecf1;
    font-weight: 600;
  }
  td {
    text-align: left;
    padding: 8px;
    border: 1px solid #e7ecf1;
    &:last-child {
      border-right: none;
    }
    &:nth-child(2n) td {
      background: #d4d8f9;
    }
  }
}
.has-background-white {
  background-color: #fff !important;
}
#app .pos-rel {
  position: relative;
}
#app .clickable {
  cursor: pointer;
}
.pos-rel {
  position: relative;
}
.clickable {
  cursor: pointer;
}
</style>
